
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"20","height":"20","viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd","stroke-opacity":".88"}},[_c('g',{attrs:{"stroke":"#000","stroke-width":".81"}},[_c('g',[_c('g',{attrs:{"transform":"translate(-571 -1403) translate(240 1332) translate(331 71)"}},[_c('rect',{attrs:{"width":"15.999","height":"12","x":"2.001","y":"4","rx":".4"}}),_c('path',{attrs:{"d":"M2 8L10 11 18 8"}})])])])])])
          )
        }
      }
    